const ProjectOptions = {
  marcus: {
    // host: "http://yunicu-api.we-fire.cn", // 测试地址
    // host: "https://yunicu-api.yunicu.com", // 正式地址
    host: '', // 最终地址，IOS12不识别response.header通配符导致跨域

    // socket: 'ws://yunicu-api.we-fire.cn', // 测试地址
    socket: "wss://yunicu-api.yunicu.com", // 正式地址

    leftBackUrl: 'http://yunicu-mp.yunicu.com/vodLive',
    rightBackUrl: 'http://yunicu-mp.yunicu.com/conference',

    publicPath: '/series/'
  }
}

//修改exportOptions切换项目

const exportOptions = ProjectOptions.marcus

// export default exportOptions

module.exports = exportOptions
